// extracted by mini-css-extract-plugin
export default {"card":"RecipeCard_card__+e5NF"};